import React, { useState, useEffect } from 'react';
import Navigation from './Navigation';
import { useSiteInfo } from '../../context/SiteInfoContext';
import { IconPhone } from '../ui/Icons';

const Header = ({ onLogoClick, onNavigate }) => {
  const { siteInfo } = useSiteInfo();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const phone = siteInfo?.phone;

  return (
    <header className="header">
      <div className="top-bar">
        <div className="container">
          <div className="top-bar-content">
            {phone && (
              <div className="contact-info">
                <a href={`tel:${phone.tel}`}>
                  <IconPhone /> {phone.display}
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
      <nav className={`main-nav ${isScrolled ? 'scrolled' : ''}`}>
        <div className="container">
          <div className="nav-container">
            <a 
              href="#home" 
              className="logo"
              onClick={(e) => { e.preventDefault(); onLogoClick && onLogoClick(); }}
            >
              JAC <span>Cars</span>
            </a>
            <Navigation isOpen={isMenuOpen} onToggle={toggleMenu} onNavigate={onNavigate} />
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
